/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {SelectItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

// get select items with uuid as value and the provided attribute as label
export function convertToSelectItems(
  labelAttribute: string,
  objects: any[],
  valueField?: string
): SelectItem[] {

  return objects.map(object => {
    return {'label': object[labelAttribute], 'value': (valueField ? object[valueField] : object)};
  });
}

// get select items with object value and the provided attribute as label
export function convertToSelectItemsWithObjectAsValue(
  labelAttribute: string,
  objects: any[],
  hasFirstValueEmpty = true
): SelectItem[] {

  const results = objects.map(object => {
    return {'label': object[labelAttribute], 'value': object};
  });
  if (hasFirstValueEmpty) {
    results.unshift({label: null, value: null});
  }
  return results;
}

// get select items with uuid as value and the provided attribute translated as label
export function convertToTranslatedSelectItems(
  translateService: TranslateService,
  labelAttribute: string,
  objects: any[],
  valueField?: string
): SelectItem[] {

  return objects.map(object => {
    const selectItem = {'value': (valueField ? object[valueField] : object), 'label': ''};
    translateService.get(object[labelAttribute]).subscribe((res) => {
      selectItem.label = res;
    });
    return selectItem;
  });
}

export function convertToSelectItemsMergeLabels(
  labelAttributes: string[],
  objects: any[],
  valueField?: string,
  attributeSeparator?: string
): SelectItem[] {

  if (attributeSeparator == null) {
    attributeSeparator = ',';
  }

  return objects.map(object => {
    let mergedLabel = '';
    for (let i = 0; i < labelAttributes.length; i++) {
      if (object[labelAttributes[i]]) {
        mergedLabel = mergedLabel.concat(object[labelAttributes[i]]);
        if (i != labelAttributes.length - 1) {
          mergedLabel = mergedLabel.concat(attributeSeparator, ' ');
        }
      }
    }
    return {'label': mergedLabel, 'value': (valueField ? object[valueField] : object)};
  });
}

export function convertEnumClassToSelectItems(
  enumClass: any
): SelectItem[] {

  const keys = Object.keys(enumClass);

  return keys.map(key => {
    return {'label': key, 'value': enumClass[key]};
  });
}

